<div class="bc-sidenav">
  <app-accordion></app-accordion>
</div>

<div class="bc-content-right">
  <app-work-item-lane-list></app-work-item-lane-list>
</div>
